import React, { useEffect, useState, useMemo } from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { IoHomeSharp } from "react-icons/io5";
import {
  Container,
  Main,
  Sidebar,
  ChangeLessonDiv,
} from "../../../style/DerslerStyle";
import {
  Button,
  CustomLink,
  CustomLinkInButton,
} from "../../../../../components/buttons/Button.styled";
import jsonData from "../../MatematikLiseDokuz.json";
import { Icons } from "../../../style/DerslerIntroStyle";
import lessonUrls from "../urlDersler.json";
import SliderDokuz from "../../SliderDokuz";
import Lesson1 from "./Lesson1";
import Lesson2 from "./Lesson2";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function GercelSayilarinUsluVeKokluGosterimleri({
  startTopicProps,
  activeLessonProp,
}) {
  const [unit, setUnit] = useState([]);
  const uniteNumarasi = 1;
  const konuNumarasi = 1;
  const uniteNo = uniteNumarasi - 1;
  const konuNo = konuNumarasi - 1;
  const navigate = useNavigate();

  useEffect(() => {
    if (jsonData?.temalar?.[uniteNo]) {
      setUnit(jsonData.temalar[uniteNo]);
    }
  }, [uniteNo]);

  const prevLessonUrl = useMemo(() => {
    const prev = lessonUrls.find(
      (lesson) => lesson.id === activeLessonProp - 1
    );
    return prev ? prev.url : null;
  }, [activeLessonProp]);

  const nextLessonUrl = useMemo(() => {
    const next = lessonUrls.find(
      (lesson) => lesson.id === activeLessonProp + 1
    );
    return next ? next.url : null;
  }, [activeLessonProp]);

  const handleMarkCompletedAndNavigate = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;

      const db = getFirestore();
      const userRef = doc(db, "users", user.uid);
      const snap = await getDoc(userRef);

      if (snap.exists()) {
        const data = snap.data();
        const dersler = [...data.derslerim["sayilar"].dersler];
        if (dersler[activeLessonProp - 1] !== 1) {
          dersler[activeLessonProp - 1] = 1;
          await updateDoc(userRef, { "derslerim.sayilar.dersler": dersler });
        }
      }
      if (nextLessonUrl) navigate(nextLessonUrl);
    } catch (err) {
      console.error("❌ Ders tamamlama hatası:", err.message);
    }
  };

  const renderLesson = () => {
    switch (activeLessonProp) {
      case 1:
        return <Lesson1 />;
      case 2:
        return <Lesson2 />;
      default:
        return <p>Ders bulunamadı.</p>;
    }
  };

  return (
    <Container>
      <Sidebar>
        <SliderDokuz
          unitNumber={uniteNo}
          konuNumber={konuNo}
          baslangicNumber={startTopicProps}
        />
      </Sidebar>
      <Main>
        <Icons>
          <CustomLink to="/">
            <IoHomeSharp />
          </CustomLink>
          <BsArrowRightShort />
          <CustomLink to="/matematik/9-sinif">
            <div> 9. Sınıf Matematik </div>
          </CustomLink>
          <BsArrowRightShort />
          <CustomLink to="/matematik/9-sinif/sayilar">
            <div>{unit?.name}</div>
          </CustomLink>
        </Icons>

        {renderLesson()}

        <ChangeLessonDiv
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            gap: "15px",
          }}
        >
          <Button
            as={CustomLinkInButton}
            to={prevLessonUrl}
            disabled={!prevLessonUrl}
          >
            Önceki Ders
          </Button>
          <Button
            onClick={handleMarkCompletedAndNavigate}
            disabled={!nextLessonUrl}
          >
            Sıradaki Ders
          </Button>
        </ChangeLessonDiv>
      </Main>
    </Container>
  );
}

export default GercelSayilarinUsluVeKokluGosterimleri;
